import React from 'react';
import styles from './CustomCardSummary.module.scss';
import type { CustomCardSummaryProps } from './types';
import { useVoucherContext } from 'blocks/e-gift-card/buy/context';

import BlackGiftCard from 'assets/svg/BlackGiftCard.svg';

const CustomCardSummary: React.FC<CustomCardSummaryProps> = ({
  customGiftCardId,
}) => {
  const { state: { customGiftCards } } = useVoucherContext();

  if (!customGiftCardId || !customGiftCards) {
    return <BlackGiftCard />;
  }

  const card = customGiftCards.find(card => card.id === customGiftCardId);

  if (!card) {
    return <BlackGiftCard />;
  }

  const { image_url, name } = card;

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        {image_url ? (
          <img src={image_url} alt={name || 'Gift card image'} />
        ) : (
          <BlackGiftCard />
        )}
      </div>
    </div>
  );
};

export default CustomCardSummary;